import React from 'react';
import AuthWrapper from '../components/molecules/AuthWrapper';
import ExploreTemplate from '../components/templates/Explore';

const Explore = () => {
  return <AuthWrapper renderProps={ExploreTemplate} />;
};

export default Explore;
